<div class="flex-1 d-flex fd-col jc-center ai-center">
  <div class="pie-container">
    <ngx-skeleton-loader class="pie" appearance="circle" [theme]="{
      height: '100%',
      width: '100%'
    }"></ngx-skeleton-loader>
  </div>
</div>
